import { ActionTypes } from '../constants/index';

export const getUserNotificationDetail = (payload: any) => ({
  type: ActionTypes.USER_NOTIFICATION_LIST_REQUEST,
  payload,
});
